/**
 * Відносний час як у прототипі v4 (since): менше хвилини — «щойно», далі хвилини, години, дні (до 30), старіше — дата. Повертає
 * одиницю й кількість; текст складає useAgo мовою інтерфейсу. Чиста функція.
 */
export function agoParts(iso: string, now = Date.now()): { unit: 'now' | 'm' | 'h' | 'd' | 'date'; count: number } {
  const m = Math.round((now - new Date(iso).getTime()) / 60000);
  if (!Number.isFinite(m) || m < 1) return { unit: 'now', count: 0 };
  if (m < 60) return { unit: 'm', count: m };
  const h = Math.round(m / 60);
  if (h < 24) return { unit: 'h', count: h };
  const d = Math.round(h / 24);
  return d < 30 ? { unit: 'd', count: d } : { unit: 'date', count: 0 };
}
